export class UserLogIn{
    userName: string;
    password: string;
}